var _circle, _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _polygon, _path6, _polygon2, _path7, _path8, _path9, _path0, _path1, _circle2, _path10, _path11, _path12, _circle3, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawCancelReCtke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 286.48239,
    height: 459.29779,
    viewBox: "0 0 586.48239 659.29779",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 332.48239,
    cy: 254,
    r: 254,
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M872.84045,221.54576h-465.293a1.807,1.807,0,0,1,0-3.61318h465.293a1.807,1.807,0,0,1,0,3.61318Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.09877,
    cy: 89.92761,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.67379,
    cy: 89.92761,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.24881,
    cy: 89.92761,
    rx: 10.58751,
    ry: 10.82345,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M850.81919,189.74427h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M850.81919,197.12864h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M850.81919,204.50331h-25.981a1.96761,1.96761,0,0,0,0,3.93445h25.981a1.96761,1.96761,0,0,0,0-3.93445Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 193.77825,
    y: 174.47256,
    width: 163.61146,
    height: 34.98639,
    rx: 17.49318,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.68559,
    y: 244.44534,
    width: 329.7968,
    height: 34.98639,
    rx: 17.49318,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110.68559,
    y: 314.41811,
    width: 329.7968,
    height: 34.98639,
    rx: 17.49318,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M466.01768,765.71674l-.69385-.06795a80.52865,80.52865,0,0,1-58.18846-34.61834,78.13222,78.13222,0,0,1-8.815-17.50409l-.21069-.58967.62374-.05048c7.447-.59927,15.09733-1.86289,18.49586-2.46418l-21.91472-7.42514-.1355-.65035a15.27244,15.27244,0,0,1,6.4285-15.86173,15.53412,15.53412,0,0,1,17.40406-.29452c2.386,1.524,4.88161,3.03341,7.29489,4.49357,8.29321,5.01633,16.8688,10.20337,23.29827,17.3012a48.6753,48.6753,0,0,1,11.63,40.25562Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "171.304 646.861 182.104 646.86 187.243 605.198 171.301 605.199 171.304 646.861",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M545.296,766.0856l33.21436-.00125v-.42a12.92866,12.92866,0,0,0-12.928-12.92775h-.0008l-6.067-4.60277-11.31973,4.60347-2.8994.0001Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "84.745 616.945 93.384 623.426 122.497 593.185 109.745 583.619 84.745 616.945",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.05131,733.68708l26.569,19.93189.25208-.336a12.92867,12.92867,0,0,0-2.58279-18.09939l-.00064-.00048-2.09079-7.32276-11.81736-3.111-2.3193-1.73993Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M495.02146,559.31013s.59626,16.26425,1.34829,29.30739c.12334,2.13917-4.8882,4.463-4.75842,6.79008.0861,1.54393,1.02808,3.04488,1.1156,4.6547.09235,1.69895-1.20823,3.20283-1.1156,4.95982.0905,1.71665,1.57423,3.68528,1.66374,5.44246.96317,18.90929,4.45459,41.5463.9584,47.87439-1.723,3.1187-23.68532,46.32448-23.68532,46.32448s12.23666,18.355,15.73284,12.23665c4.6177-8.081,40.20616-45.88745,40.20616-53.10709,0-7.21088,8.23345-61.25321,8.23345-61.25321l5.741,31.98169L543.094,640.858l-.82714,3.72,1.70119,5.02047.09191,4.96838,1.65618,9.22613s-4.982,71.8816-2.17636,73.88315c2.8144,2.01035,16.44087,5.62017,18.049,2.01035,1.59957-3.60982,12.01082-75.01945,12.01082-75.01945s1.67811-32.72426,3.49619-63.14113c.10478-1.76554,1.34607-3.89827,1.4422-5.63761.11363-2.019-.673-4.64113-.56815-6.599.11363-2.24626,1.11006-3.82833,1.20619-5.97851.74292-16.61563-3.42763-36.84914-4.75609-38.84193-4.012-6.01345-7.62177-10.82071-7.62177-10.82071s-54.03558-17.754-68.47485.28627Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M548.9146,392.06118,527.4937,387.777l-9.99641,13.56657,0,0c-18.65262,18.34056-18.93359,34.52754-15.60378,60.4738v36.41552l-2.41,24.41188s-8.53157,17.84519.26789,22.00005,66.59857,3.80067,72.117,2.14209.73514-3.69485-.714-11.42447c-2.72213-14.51927-.90128-7.5156-.714-12.13851,2.68585-66.31364-3.57015-93.5379-4.20545-100.69375l-10.894-19.75857Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M661.8159,445.52838a8.66045,8.66045,0,0,1-12.98379,2.788l-46.26043,29.37309.13337-15.99241,44.93844-26.07846a8.70737,8.70737,0,0,1,14.17241,9.90978Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#a0616a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M532.00172,410.58168l-5.26668-.55806a13.93555,13.93555,0,0,0-12.57948,5.491,13.57984,13.57984,0,0,0-2.37491,4.99164l-.00316.01446a13.92252,13.92252,0,0,0,5.258,14.48116l18.19032,13.411c12.76546,17.249,36.75655,28.69271,64.89831,37.98978L643.8669,459.236l-15.47185-18.73843-30.00338,16.07979-44.59832-34.52375-.02569-.02075-16.97426-10.936Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.30377,
    cy: 248.60526,
    r: 24.97979,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M542.25373,381.54788c-.20135.00662-.40317.01107-.60478.01656-.08633.22388-.17937.44583-.2868.66356Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M549.10927,357.25566a4.42251,4.42251,0,0,0,.17916.72449A3.40858,3.40858,0,0,0,549.10927,357.25566Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M566.97535,332.65162c-1.0282,3.19273-1.94589-.85715-5.32825-.1287-4.06884.87624-8.80378.57531-12.13589-1.91878a18.80135,18.80135,0,0,0-17.22331-2.6251c-5.70151,2.01706-15.25345,3.43932-16.73908,9.30178-.51639,2.03781-.72152,4.24932-1.97321,5.93821-1.09436,1.47661-2.82165,2.31855-4.26609,3.455-4.87727,3.83743-1.14954,14.73981,1.15881,20.50046,2.3084,5.76066,7.60352,9.9572,13.42528,12.10678,5.63283,2.07977,11.74641,2.44663,17.75534,2.28316,1.04516-2.7106.59362-5.84137-.26876-8.65133-.93359-3.042-2.31593-5.97791-2.70594-9.136s.46645-6.74528,3.11443-8.50987c2.4339-1.62191,6.39467-.63389,7.32059,1.98842-.54028-3.27842,2.78072-6.45089,6.20509-7.00881,3.67649-.599,7.35293.72832,11.01883,1.389S568.698,336.86284,566.97535,332.65162Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.36232,
    cy: 285.71052,
    r: 51.12007,
    fill: "#76ff7e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M669.16358,372.36791l-13.42827,13.42828L642.307,372.36791a5.56617,5.56617,0,0,0-7.87175,7.87175l13.42828,13.42827-13.42828,13.42828A5.56617,5.56617,0,0,0,642.307,414.968l13.42828-13.42828L669.16358,414.968a5.56617,5.56617,0,0,0,7.87175-7.87175l-13.42828-13.42828,13.42828-13.42827a5.56617,5.56617,0,0,0-7.87175-7.87175Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M635.59068,350.70126a8.66046,8.66046,0,0,1-6.97689,11.29932L617.7833,415.71749l-11.44789-11.16785,12.29269-50.48207a8.70738,8.70738,0,0,1,16.96258-3.36631Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#a0616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M520.502,420.18219l-4.04883,3.41413a13.93553,13.93553,0,0,0-4.74648,12.87887,13.57976,13.57976,0,0,0,1.95783,5.16948l.00825.01229a13.92254,13.92254,0,0,0,14.08981,6.23117l22.27073-3.84171c21.28459,2.72994,46.15154-6.65967,72.343-20.53054L633.056,373.14317l-24.233-1.80811-9.16819,32.78272-55.78814,8.28148-.03276.00416L524.191,417.08108Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M647.31367,766.94786l-271.75.30733a1.19068,1.19068,0,0,1,0-2.38137l271.75-.30733a1.19068,1.19068,0,0,1,0,2.38137Z",
    transform: "translate(-374.37298 -107.95741)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCancelReCtke);
export default __webpack_public_path__ + "static/media/undraw_cancel_re_ctke.e09d8a1d651bc92ed410050ad7d3796b.svg";
export { ForwardRef as ReactComponent };